import React from 'react'

export function Pill({ children, color = '#6366f1' }: { children: React.ReactNode; color?: string }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', background: `${color}14`, color, border: `1px solid ${color}30`, borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.4 }}>
      {children}
    </span>
  )
}

export function SectionHead({ badge, title, sub, align = 'center' }: { badge: string; title: string; sub?: string; align?: 'center' | 'left' }) {
  return (
    <div style={{ textAlign: align, marginBottom: 48 }}>
      <Pill>{badge}</Pill>
      <h2 style={{ fontSize: 34, fontWeight: 800, color: 'var(--text-primary)', margin: '14px 0 12px', lineHeight: 1.2 }}>{title}</h2>
      {sub && <p style={{ fontSize: 16, color: 'var(--text-secondary)', maxWidth: 560, margin: align === 'center' ? '0 auto' : 0, lineHeight: 1.65 }}>{sub}</p>}
    </div>
  )
}

export function OSWindow({ title, color = '#6366f1', children, style }: { title: string; color?: string; children: React.ReactNode; style?: React.CSSProperties }) {
  return (
    <div style={{ background: 'var(--card-bg)', border: '1px solid var(--border-color)', borderRadius: 12, overflow: 'hidden', backdropFilter: 'blur(20px)', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', ...style }}>
      <div style={{ display: 'flex', alignItems: 'center', height: 32, padding: '0 12px', background: 'var(--body-bg)', borderBottom: '1px solid var(--border-color)', gap: 6 }}>
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ff5f57', display: 'block' }} />
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#febc2e', display: 'block' }} />
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#28c840', display: 'block' }} />
        <span style={{ flex: 1, textAlign: 'center', fontSize: 10, fontWeight: 600, color: 'var(--text-tertiary)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{title}</span>
        <span style={{ width: 10, height: 10, borderRadius: 3, background: `${color}40`, display: 'block' }} />
      </div>
      <div style={{ padding: 16 }}>{children}</div>
    </div>
  )
}
